export const kyc = {
	heading: {
		sv: "KYC",
	},
	subHeading: {
		sv: "Det är frågor vi måste ställa enligt lag. De bygger på EU:s regler för att bekämpa penningtvätt och finansiering av terrorism",
	},
	applicationQuestions: {
		heading: {
			sv: "Om företaget",
		},
		description: {
			sv: "Generella frågor om ditt företag och den verksamhet ni bedriver.",
		},
	},
	amlQuestions: {
		description: {
			sv: "Frågor om hur ditt företag planerar att använda kontot.",
		},
	},
	beneficialOwnership: {
		title: { sv: "Uppgifter om verklig huvudman" },
		description: {
			sv: "Den eller de personer som ytterst äger eller kontrollerar företaget.",
		},
		noBoTitle: { sv: "Det finns inga verkliga huvudmän" },
		noBoDescription: {
			sv: "Du har anmält till Bolagsverket att företaget inte har någon verklig huvudman.",
		},
		boMissingTitle: {
			sv: "Vänligen uppdatera din information om verkliga huvudmän",
		},
		stepOneTitle: { sv: "Steg 1. Anmäl hos Bolagsverket" },
		stepOneDescription: {
			sv: "För att ansöka om ett bankpaket behöver dina uppgifter om verkliga huvudmän stämma. Eftersom du angivit att informationen om verkliga huvudmän inte stämmer så behöver du gå till Bolagsverket och anmäla den eller de personer som är verkliga huvudmän för organisationen. ",
		},
		stepTwoTitle: {
			sv: "Steg 2. Kontrollera uppgifterna hos Svea",
		},
		stepTwoDescription: {
			sv: "När du anmält verkliga huvudmän till Bolagsverket tar det minst 24 timmar innan du kan slutföra din ansökan. När Svea har fått de uppdaterade uppgifterna om verkliga huvudmän kan du fortsätta din ansökan. Kontrollera att de stämmer innan du klickar spara och går vidare.",
		},
		warningTitle: {
			sv: "Viktigt!",
		},
		warningDescription: {
			sv: " Du kommer inte kunna genomföra din ansökan om inte vi får in rätt uppgifter.",
		},
		share: {
			sv: "Andel: {0}-{1}%",
		},
		button: {
			invalid: { sv: "Uppgifterna stämmer inte" },
			confirm: { sv: "Uppgifterna stämmer" },
			continue: { sv: "Fortsätt" },
			undo: { sv: "Ångra" },
			link: { sv: "Gå till bolagsverket" },
			linkUrl: {
				sv: "https://bolagsverket.se/sjalvservice/etjanster/verklighuvudman/anmalverklighuvudman.3083.html",
			},
		},
		infoHeading: { sv: "Vad är en verklig huvudman?" },
		infoText1: {
			sv: `
**Verklig huvudman kontrollerar företaget genom att:**

- Ha mer än 25 procent av rösterna
- Ha rätt att utse eller avsätta mer än häften av styrelsen.
`,
		},
		infoText2: {
			sv: `
**Exempel på vem som är verklig huvudman, det kan finnas fler än en verklig huvudman:**

- En aktieägare kontrollerar mer än 25 procent i ett aktiebolag och är verklig huvudman.
- Två registrerade parter kontrollerar vardera 15 procent av rösterna i ett aktiebolag. Eftersom de är närstående ska deras röster räknas samman. I detta fall är båda verkliga huvudmän. Om aktiebolaget kommer fram till att endast en av dem har den yttersta kontrollen över aktiebolaget så är den personen ensam verklig huvudman.
- En aktieägare kontrollerar 10 procent av rösterna i ett aktiebolag. Personen har genom avtal med övriga aktieägare rätt att utse mer än hälften av styrelseledamötena. Personen är verklig huvudman.
- En aktieägare äger ett aktiebolag till 100 procent. Aktiebolaget äger i sin tur ett annat aktiebolag till 100 procent. Personen är verklig huvudman i båda aktiebolagen.
- Fyra aktieägare kontrollerar 25 procent var av rösterna i ett aktiebolag. Ingen av dem uppnår mer än 25 procent. Alltså är ingen av dess verkliga huvudmän.
- Aktiebolaget ägs av ett utländskt företag och kan inte komma fram till vem som kontrollerar det utländska företaget. Därför kan aktiebolaget inte avgöra vem som är verklig huvudman.
- Hos [Bolagsverket](https://bolagsverket.se/omoss/flerverksamheter/omverklighuvudman.2539.html) kan du läsa mer om verklig huvudman.
`,
		},
	},
	beneficialOwnerQuestions: {
		heading: {
			sv: "Skatteskyldighet och politisk exponering (PEP)",
		},
		description: {
			sv: "Uppgifter om skatterättlig hemvist och frågor för att fastställa om någon i företaget är i politiskt utsatt ställning. Läs mer om Skatteregistreringsummer (TIN) hos [Skatteverket.](https://www.skatteverket.se/foretag/skatterochavdrag/kontrolluppgifter/kontrolluppgifterinternationellt.4.96cca41179bad4b1aaa7cd.html)",
		},
		taxNumberFor: {
			sv: "Skatteregistreringsnummer (TIN) för",
		},
		addPerson: {
			sv: "Lägg till person",
		},
		addedPersons: {
			sv: "Tillagda personer",
		},
		atLeastOnePerson: {
			sv: "Lägg till minst en person",
		},
		name: {
			sv: "För- och efternamn",
		},
		birthDate: {
			sv: "Födelsedatum",
		},
	},
	sniCode: {
		heading: {
			sv: "Din bransch",
		},
		description: {
			sv: "Uppgifter om de branscher där ditt företag är verksamt.",
		},
		formLegend: {
			sv: "SNI-kod",
		},
		linkText: {
			sv: "Se vilka koder som finns på Bolagsverket",
		},
		linkUrl: {
			sv: "https://sni2007.scb.se/",
		},
		buttonText: {
			sv: "Lägg till SNI-kod",
		},
		inputLabel: {
			sv: "SNI-kod med 5 siffror",
		},
		addMore: {
			sv: "Lägg till en annan kod",
		},
		required: {
			sv: "Du måste lägga till minst en SNI-kod",
		},
		searchSni: {
			sv: "Sök och lägg till branschkod (SNI) som bäst förklarar företagets huvudsakliga verksamhet. Du behöver lägga till minst 1 SNI-kod.",
		},
		searchSniLabel: {
			sv: "Sök SNI-kod",
		},
		tooManyResults: {
			sv: "Visar de 20 mest relevanta sökresultaten",
		},
		noResults: {
			sv: "Sökningen gav inget resultat, försök igen.",
		},
		suggestions: {
			sv: "Sökresultat",
		},
	},
};
